var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.566 0.175119C15.8816 0.393869 16.0472 0.771994 15.9878 1.15012L13.9878 14.1501C13.941 14.4532 13.7566 14.7189 13.4878 14.8689C13.2191 15.0189 12.8972 15.0376 12.6128 14.9189L8.87533 13.3657L6.7347 15.6814C6.45658 15.9845 6.01908 16.0845 5.6347 15.9345C5.25033 15.7845 5.00033 15.4126 5.00033 15.0001V12.3876C5.00033 12.2626 5.0472 12.1439 5.13158 12.0532L10.3691 6.33762C10.5503 6.14074 10.5441 5.83762 10.3566 5.65012C10.1691 5.46262 9.86595 5.45012 9.66908 5.62824L3.31283 11.2751L0.553451 9.89387C0.222201 9.72824 0.00970049 9.39699 0.000325486 9.02824C-0.00904951 8.65949 0.184701 8.31574 0.503451 8.13137L14.5035 0.131369C14.8378 -0.0592555 15.2503 -0.0405055 15.566 0.175119Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendImageIcon);
export default __webpack_public_path__ + "static/media/send-image-icon.54b3f0bfb08a825d0a80b9a654e64269.svg";
export { ForwardRef as ReactComponent };